export default __webpack_public_path__ + "static/media/calories.ceb26547.svg";